<template>
  <v-container fluid class="pa-6">
    <v-row align="center" class="mb-6">
      <h2 class="ml-4 text-h5 font-weight-bold">{{ $t('message.automation_sequences') }}</h2>
      <v-spacer></v-spacer>
      <v-btn color="primary" depressed @click="goToBuilder('new')">
        <v-icon left>mdi-plus</v-icon>
        {{ $t('message.create_sequence') }}
      </v-btn>
    </v-row>

    <v-row class="mb-6">
      <v-col cols="12" sm="4">
        <v-card outlined class="pa-4 text-center">
          <div class="text-overline grey--text">{{ $t('message.active_sequences') }}</div>
          <div class="text-h4">{{ activeCount }}</div>
        </v-card>
      </v-col>
    </v-row>

    <v-card outlined>
      <v-data-table :headers="headers" :items="sequences" :loading="loading"
        :no-data-text="$t('message.no_sequences_found')" class="elevation-0">
        <template v-slot:item.triggerEvent="{ item }">
          <v-chip small label outlined color="primary" class="text-uppercase font-weight-bold">
            {{ formatTrigger(item.triggerEvent) }}
          </v-chip>
        </template>

        <template v-slot:item.steps="{ item }">
          <div class="d-flex align-center">
            <v-icon x-small class="mr-1">mdi-email-multiple-outline</v-icon>
            {{ item.steps ? item.steps.length : 0 }} {{ $t('message.steps') }}
          </div>
        </template>

        <template v-slot:item.isActive="{ item }">
          <v-chip :color="item.isActive ? 'success' : 'grey lighten-1'" small dark class="font-weight-bold">
            {{ item.isActive ? $t('message.active') : $t('message.inactive') }}
          </v-chip>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn icon small color="primary" @click="goToBuilder(item._id)">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon small color="error" @click="confirmDelete(item)">
            <v-icon small>mdi-delete-outline</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="deleteDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">{{ $t('message.delete_sequence') }}?</v-card-title>
        <v-card-text>{{ $t('message.delete_sequence_warning') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDialog = false">{{ $t('message.cancel') }}</v-btn>
          <v-btn color="error" text @click="deleteSequence">{{ $t('message.delete') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from "@/services/Api";

export default {
  name: "AutomationsList",
  data() {
    return {
      managedAcademyId: this.$store.state.managedAcademy,
      loading: true,
      sequences: [],
      deleteDialog: false,
      selectedItem: null,
      headers: [
        { text: this.$t('message.name'), value: 'name', align: 'start' },
        { text: this.$t('message.trigger'), value: 'triggerEvent' },
        { text: this.$t('message.steps'), value: 'steps', sortable: false },
        { text: this.$t('message.status'), value: 'isActive' },
        { text: this.$t('message.actions'), value: 'actions', sortable: false, align: 'end' },
      ],
    };
  },
  computed: {
    activeCount() {
      return this.sequences.filter(s => s.isActive).length;
    }
  },
  created() {
    this.fetchSequences();
  },
  methods: {
    async fetchSequences() {
      this.loading = true;
      try {
        const res = await Api().get(`automations/managedacademy/${this.managedAcademyId}`);
        this.sequences = res.data || [];
      } catch (err) {
        console.error("Fetch error", err);
      } finally {
        this.loading = false;
      }
    },
    goToBuilder(id) {
      this.$router.push({ name: 'automation-builder', params: { id } });
    },
    formatTrigger(trigger) {
      return trigger.replace(/_/g, ' ');
    },
    confirmDelete(item) {
      this.selectedItem = item;
      this.deleteDialog = true;
    },
    async deleteSequence() {
      try {
        // You'll need to add this DELETE route to your controller
        await Api().delete(`automations/managedacademy/${this.managedAcademyId}/sequence/${this.selectedItem._id}`);
        this.fetchSequences();
        this.deleteDialog = false;
      } catch (err) {
        console.error("Delete error", err);
      }
    }
  }
};
</script>